<template>
    <div>
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            v-model="model.periodo"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            defaultOptionText="Todas"
                            :options="unidades"
                            label="Unidade executante"
                            show-default-option
                            text-field="unidadeNome"
                            v-model="model.unidadeId"
                            value-field="unidadeId"
                            :validations="validations.unidadeId"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            defaultOptionText="Todos"
                            :options="grupoExames"
                            label="Grupo de exames"
                            show-default-option
                            text-field="grupoExame"
                            v-model="model.grupoExameId"
                            :validations="validations.grupoExameId"
                            value-field="grupoExameId"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            defaultOptionText="Todos"
                            :options="profissionais"
                            label="Profissional executante"
                            show-default-option
                            text-field="profissionalNome"
                            v-model="model.profissionalId"
                            :validations="validations.profissionalId"
                            value-field="profissionalId"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            defaultOptionText="Todos"
                            :options="status"
                            label="Status"
                            show-default-option
                            text-field="statusNome"
                            v-model="model.statusId"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-button
                            :label="false"
                            color="primary"
                            class="float-left"
                            @click="$refs.Form.validate(search)"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="resetForm()"
                            class="mr-2 float-left"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            title="Totais"
            type="fieldset"
            no-margin-top
            v-if="notSaveLancamentos"
        >
            <rkm-row>
                <rkm-col cols="3">
                    Total de atendimento
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totalAtendimento() }}
                        </strong>
                    </rkm-alert>
                </rkm-col>

                <rkm-col cols="3">
                    Total de vagas
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totalVagas() }}
                        </strong>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="notSaveLancamentos"
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-button
                    :disabled="notSaveLancamentos.length === 0"
                    @click="impressao()"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="notSaveLancamentos.length === 0"
                    @click="exportar()"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :items="notSaveLancamentos"
                :fields="fields"
                ref="Table"
                sort-by="data"
                hide-filters
            >
                <template v-slot:cell(jornadaId)="{item}">
                    {{totalAtendimentoItem(item)}} / {{ item.vagas }}
                </template>
            </rkm-table>

            <rkm-row class="mt-2">
                <rkm-col>
                    <p class="m-0">
                        AT = Atendimentos | V = Vagas
                    </p>
                    <p class="m-0">
                        Linhas em <span class="warning">amarelo</span> representam exames com urgência.
                    </p>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>

// Mixins.
import { repository, error, object, data, stringCase, file } from '@/mixins'

// Enuns.
import statusFechamento from '@/enums/exame-imagem/fechamento/status'
import tipoControleJornada from '@/enums/exame-imagem/tipoControleJornada'

// Vuex.
import { mapActions } from 'vuex'

// Moment.
import moment from 'moment'

export default {
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.exameImagem'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            relatorio: this.getConectaSusRepository('exameImagem.relatorioCotaProfissional'),
            exportacao: this.getConectaSusRepository('exportacao.exameImagem'),
        }
        this.load()
    },
    computed: {
        fields() {
            let fields = [
                { key: 'data', label: 'Data', sortable: true },
                { key: 'profissionalNome', label: 'Profissional', sortable: true },
                { key: 'grupo', label: 'Grupo de exame', sortable: true },
                { key: 'nomeSemana', label: 'Dia da semana', sortable: true },
                { key: 'horaInicial', label: 'Início', sortable: true },
                { key: 'horaFim', label: 'Fim', sortable: true },
                { key: 'statusNome', label: 'Status', sortable: true},
                { key: 'jornadaId', label: 'AT/V', sortable: true},
            ]

            this.selectedCols.map(map => {
                const col = this.cols.find(find => find.value === map)
                fields.push({ key: col.value, label: col.text, sortable: true })
            })

            return fields
        },
        fieldsPaciente(){

            return {
                paciente: [
                    { key: 'cidadao.nome', searchable: true },
                ],
            }
        },
        validations() {
            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                }
            }
        },
        unidades(){

            let unidadeOrigem = []

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetUnidade()
                this.resetDatatable()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                this.data.model.relatorioCotaProfissional.filter(agendamento =>
                    moment(agendamento.data, 'DD/MM/YYYY').isBetween(start, end))
                        .map(unidade => {

                            let verifyUnidade = unidadeOrigem.find(u => u.unidadeId === unidade.unidadeId)

                            if(!verifyUnidade){

                                unidadeOrigem.push({
                                    unidadeId: unidade.unidadeId,
                                    unidadeNome: unidade.nomeFantasia
                                })
                            } else {
                                this.resetUnidade()
                                this.resetDatatable()
                            }
                        })
            }

            return unidadeOrigem
        },
        grupoExames(){

            let grupoExameOrigem = []

            if (this.model.periodo.start && this.model.periodo.end){

                this.resetGrupo()
                this.resetDatatable()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                this.data.model.relatorioCotaProfissional.filter(g => moment(g.data, 'DD/MM/YYYY').isBetween(start, end)
                    && g.unidadeId === this.model.unidadeId)
                        .map(grupo => {

                            if(grupoExameOrigem){

                                let verifyGrupoExame = grupoExameOrigem.find(e => e.grupoExameId === grupo.grupoExameId)

                                if(!verifyGrupoExame){

                                    grupoExameOrigem.push({
                                        grupoExameId: grupo.grupoExameId,
                                        grupoExame: grupo.grupo
                                    })
                                } else {
                                    this.resetGrupo()
                                    this.resetDatatable()
                                }
                            }
                        })

                grupoExameOrigem.sort((a,b) => (a.grupoExame > b.grupoExame) ? 1 : ((b.grupoExame > a.grupoExame) ? -1 : 0));
            }

            return grupoExameOrigem
        },
        profissionais(){

            let profissionalOrigem = []

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetProfissional()
                this.resetDatatable()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                if(this.verificaGrupo == true){

                    this.data.model.relatorioCotaProfissional.filter(u => moment(u.data, 'DD/MM/YYYY').isBetween(start, end)
                        && u.unidadeId === this.model.unidadeId && u.grupoExameId === this.model.grupoExameId)
                            .map(prof => {

                                if (profissionalOrigem){

                                    let verifyProfissional = profissionalOrigem.find(u => u.profissionalId === prof.profissionalId)

                                    if (!verifyProfissional) {

                                        profissionalOrigem.push({
                                            profissionalId: prof.profissionalId,
                                            profissionalNome: prof.profissionalNome,
                                        })
                                    } else {
                                        this.resetProfissional()
                                        this.resetDatatable()
                                    }
                                }
                            })

                    profissionalOrigem.sort((a,b) => (a.profissionalNome > b.profissionalNome) ? 1 : ((b.profissionalNome > a.profissionalNome) ? -1 : 0));

                } else {

                    this.data.model.relatorioCotaProfissional.filter(u => moment(u.data, 'DD/MM/YYYY').isBetween(start, end)
                        && u.unidadeId === this.model.unidadeId)
                            .map(prof => {

                                if (profissionalOrigem){

                                    let verifyProfissional = profissionalOrigem.find(u => u.profissionalId === prof.profissionalId)

                                    if (!verifyProfissional) {

                                        profissionalOrigem.push({
                                            profissionalId: prof.profissionalId,
                                            profissionalNome: prof.profissionalNome,
                                        })
                                    } else {
                                        this.resetProfissional()
                                        this.resetDatatable()
                                    }
                                }
                            })

                    profissionalOrigem.sort((a,b) => (a.profissionalNome > b.profissionalNome) ? 1 : ((b.profissionalNome > a.profissionalNome) ? -1 : 0));
                }
            }

            return profissionalOrigem
        },
        status(){

            let statusOrigem = []

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetStatus()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                this.data.model.relatorioCotaProfissional.filter(u => moment(u.data, 'DD/MM/YYYY').isBetween(start, end)
                    && u.unidadeId === this.model.unidadeId)
                        .map(status => {

                            if (statusOrigem){

                                let verifyStatus = statusOrigem.find(u => u.statusId === status.statusId)

                                if (!verifyStatus) {

                                    statusOrigem.push({

                                        statusId: status.statusId,
                                        statusNome: status.statusNome,
                                    })
                                } else {
                                    this.resetStatus()
                                }
                            }
                        })

                statusOrigem.sort((a,b) => (a.statusNome > b.statusNome) ? 1 : ((b.statusNome > a.statusNome) ? -1 : 0));
            }

            return statusOrigem
        }
    },
    data: () => ({
        notSaveLancamentos: null,
        model: {
            prontuario: '',
            periodo: {
                start: null,
                end: null,
            },
            paciente: null,
            exame: null,
            unidadeId: null,
            grupoExameId: null,
            statusId: null,
            procedimento: '',
            profissionalId: null
        },
        indeterminate: false,
        additionals: {},
        enums:{
            statusFechamento,
            tipoControleJornada
        },
        selectedCols: [],
        cols: [
            { value: 'exameCodigo', text: 'Procedimento', },
            { value: 'unidadeSolicitanteNome', text: 'Unidade solicitante', },
            { value: 'nomeFantasia', text: 'Unidade executante', },
        ],
        verificaGrupo: false,
        vagas: 0
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.model.periodo.start = this.data.model.periodo.start
            this.model.periodo.end = this.data.model.periodo.end
        },
        search() {

            this.setLoading()
            this.repositories.relatorio.datatable(this.getSearchParams())
                .then(({ data }) => {

                    this.notSaveLancamentos = data
                    this.handleSelectedColumns()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setDefaultValues() {
            this.model.periodo.start = this.data.model.periodo.start
            this.model.periodo.end = this.data.model.periodo.end
            this.resetDatatable()
        },
        getSearchParams() {
            const params = this.clone(this.model)
            this.formateDates(params.periodo, ['start', 'end'], 'DD/MM/YYYY')
            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetDatatable(){
            this.notSaveLancamentos = null
            this.model.paciente = null
            this.model.statusId = null
            this.model.procedimento = null
        },
        resetUnidade(){
            this.model.unidadeId = null
        },
        resetGrupo(){
            this.model.grupoExameId = null
        },
        resetProfissional(){
            this.model.profissionalId = null
        },
        resetStatus(){
            this.model.statusId = null
        },
        resetForm() {
            this.model.prontuario =  null
            this.model.paciente = null
            this.model.grupoExameId =  null
            this.model.dataNascimento = null
            this.model.unidadeId = null
            this.model.unidadeSolicitanteId = null
            this.model.statusId = null
            this.model.procedimento = null

            this.$nextTick()
                .then(() => {

                    this.setDefaultValues()
                    this.$refs.Form.resetValidator()
                })
        },
        handleSelectedColumns(selected) {

            if (selected) {
                this.cols.map(col => {
                    this.selectedCols.push(col.value)
                })
            } else {
                this.selectedCols = []
            }
        },
        impressao() {

            this.setLoading()

            const filter = this.getFilterExportPrint()

            filter.columns = this.fields

            this.repositories.impressao.relatorioCotaProfissional(filter)
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')
                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .finally(() => this.unsetLoading())
        },
        exportar() {

            this.setLoading()

            const filter = this.getFilterExportPrint()
            filter.columns = this.fields

            this.repositories.exportacao.exportCotaProfissional(filter)
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .finally(() => this.unsetLoading())
        },
        getFilterExportPrint() {

            const filter = this.getSearchParams()

            const $this = this

            const cols = this.fields.map(function (field) {
                field.key = $this.camelToSnake(field.key)
                return field
            })

            filter.columns = cols

            const executantes = this.data.form.unidades.find(u => u.id === this.model.unidadeId)
            filter.executantes = executantes ? executantes.nomeFantasia : 'Todas'

            const grupos = this.data.form.grupos.find(g => g.id === this.model.grupoExameId)
            filter.grupos = grupos ? grupos.nome : 'Todos'

            const status = this.data.form.status.find(e => e.id === this.model.statusId)
            filter.status = status ? status.nome : 'Todos'

            const profissional = this.data.form.profissionais.find(p => p.id === this.model.profissionalId)
            filter.profissional = profissional ? profissional.nome : 'Todos'

            const totalAtendimento = this.notSaveLancamentos.map(item => item.tipoJornada == this.enums.tipoControleJornada.ATENDIMENTO && item.soma)
                .reduce((accumulator,value) => accumulator + value,0)
            filter.totalAtendimento = totalAtendimento

            const totalExames = this.notSaveLancamentos.map(item => item.tipoJornada == this.enums.tipoControleJornada.EXAME && item.soma)
                .reduce((accumulator,value) => accumulator + value,0)
            filter.totalExames = totalExames


            var total = 0;
            var numeros = this.notSaveLancamentos.map(item => [item.vagas]);

            for ( var i = 0; i < numeros.length; i++ ){
                total += numeros[i];
            }

            this.vagas = total

            const vagaTotal = this.notSaveLancamentos.map(item => item.vagas)
                .reduce((accumulator,value) => accumulator + value,0)
            filter.vagaTotal = vagaTotal

            return filter
        },
        totalVagas(){

            var total = 0;
            var numeros = this.notSaveLancamentos.map(item => [item.vagas]);

            for ( var i = 0; i < numeros.length; i++ ){
                total += numeros[i];
            }

            this.vagas = total

            return this.notSaveLancamentos.map(item => item.vagas)
                .reduce((accumulator,value) => accumulator + value,0)
        },
        totalAtendimento(){
            return this.notSaveLancamentos.map(item => item.tipoJornada == this.enums.tipoControleJornada.ATENDIMENTO && item.soma)
                .reduce((accumulator,value) => accumulator + value,0)
        },
        totalAtendimentoItem(item){

            if(item.tipoJornada == this.enums.tipoControleJornada.ATENDIMENTO){
                return item.soma
            }  else {
                return 0
            }
        },
        totalExames(){
            return this.notSaveLancamentos.map(item => item.tipoJornada == this.enums.tipoControleJornada.EXAME && item.soma)
                .reduce((accumulator,value) => accumulator + value,0)
        },
        totalExamesItem(item){

            if(item.tipoJornada == this.enums.tipoControleJornada.EXAME){
                return item.soma
            } else {
                return 0
            }
        },
    },
    mixins: [repository, error, object, data, stringCase, file],
    watch: {
        'selectedCols': function (newValue) {

            this.indeterminate = false

            if (newValue.length > 0 && newValue.length != this.cols.length) {

                this.indeterminate = true
            }
        },
        'model.grupoExameId': function(){

            if(this.model.grupoExameId == null || this.model.grupoExameId == ''){
                this.verificaGrupo = false
            } else {
                this.verificaGrupo = true
            }
        }
    },
    props: {
        data: { type: Object, required: true }
    }
}
</script>

<style scoped>
    .warning {
        color: var(--warning);
    }
</style>